import React, { useState } from "react";
import { Image, Button } from "react-bootstrap";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../../enums/GlobalEnums";

const AllSeatingUserModal = (props) => {
  //state
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });

  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const calcTotalPersons = (seating) => {
    let total;
    total =
      seating.adult_count +
      seating.kids_count +
      seating.high_chair +
      seating.handicap_chair;
    return total;
  };

  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.seating && props.seating.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props?.seating?.wait_time_date || props?.seating?.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = props.seating && props.seating.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.seating && props.seating.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  return (
    <>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td colSpan="6" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr
                  className="cursor super_admin_user_view_inside_table_body"
                  onClick={showTr}
                >
                  <td width="16.66%">
                    <div className="d-flex flex-column align-items-start">
                      <div className="enImage45 ">
                        <Image
                          //src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (props &&
                              props.seating &&
                              props.seating.restaurant_id &&
                              props.seating.restaurant_id.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="restaurant logo"
                          title="restaurant logo"
                          fluid
                        />
                      </div>
                      <div className="f11-500 mt-1">
                        {props &&
                          props.seating &&
                          props.seating.restaurant_id &&
                          props.seating.restaurant_id.restaurant_name}
                      </div>
                    </div>
                  </td>
                  <td width="16.66%">
                    <div className="d-flex">
                      <div>
                        {props.seating.service_type === "RESERVATION" ? (
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/reservation.svg")}
                            alt="icon img"
                            title="icom img"
                            width="13px"
                          />
                        ) : props.seating.service_type === "SEATING" &&
                          props.seating.isWalkIn === true ? (
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/walkin.svg")}
                            alt="icon img"
                            title="icom img"
                            width="9px"
                          />
                        ) : props.seating.service_type === "SEATING" &&
                          props.seating.isWalkIn === false ? (
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/clock.svg")}
                            alt="icon img"
                            title="icom img"
                            width="13px"
                          />
                        ) : null}
                      </div>
                      <div className="pl-2">
                        <div className="f15-500">
                          {" "}
                          {props.seating.service_type === "RESERVATION"
                            ? "RESERVATION"
                            : props.seating.service_type === "SEATING" &&
                              props.seating.isWalkIn === true
                            ? "Walk-In"
                            : props.seating.service_type === "SEATING" &&
                              props.seating.isWalkIn === false
                            ? "Waitlist"
                            : null}
                        </div>
                        <div className="f13-400">
                          #{props && props.seating && props.seating.diner_id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td width="16.66%">
                    <div className="adult-total-box">
                      <div className="d-flex align-items-center">
                        <p className="f18-700 text-dark mr-2">
                          {props &&
                          props.seating &&
                          props.seating.adult_count ? (
                            calcTotalPersons(props.seating)
                          ) : (
                            <> </>
                          )}
                        </p>
                        <div className="adult-total-box-two mr-2">
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/employees.png")}
                                fluid
                                alt="Adult"
                                title="Adult"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {props &&
                                props.seating &&
                                props.seating.adult_count}
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/children.png")}
                                fluid
                                alt="Children"
                                title="Children"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {props &&
                                props.seating &&
                                props.seating.kids_count}
                            </span>
                          </div>
                        </div>
                        <div className="adult-total-box-three">
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/highchair.png")}
                                fluid
                                alt="Highchair"
                                title="Highchair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {" "}
                              {props &&
                                props.seating &&
                                props.seating.high_chair}
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/wheelchair.png")}
                                fluid
                                alt="Wheel Chair"
                                title="Wheel Chair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {props &&
                                props.seating &&
                                props.seating.handicap_chair}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td width="16.66%">
                    <div className="f13-400">
                      <span className={`${props?.seating?.diner_status === "REJECTED" ? "enYellowDot" : props?.seating?.diner_status === "CANCELLED" ? "enRedDot" : props?.seating?.diner_status === "SEATED" ?  "enGreenDot" : "enDarkGreenDot" } mr-1`}></span>
                      {props && props.seating && props.seating.diner_status}
                    </div>
                    {/* <div className="f13-400">
                          <span className="enGreenDot mr-1"></span>Seated
                        </div> */}
                  </td>
                  <td width="16.66%">
                    <div className="f12-400">
                      {" "}
                      {moment(props.seating && props.seating.createdAt).format(
                        "Do MMM, YYYY"
                      )}
                    </div>
                    <div className="f15-700">
                      {moment(props.seating && props.seating.createdAt).format(
                        "LT"
                      )}
                    </div>
                  </td>
                  <td width="16.66%">
                    <div className="d-flex">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={() => props.handleShowView(props.seating)}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      {(
                      props?.seating?.diner_status === "SEATED" || props?.seating?.diner_status === "PENDING" || props?.seating?.diner_status === "NOTSEATED") ? (
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={() => props.onClickVendorId(props.seating)}
                        >
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </Button>
                      ) : (
                        <> </>
                      )}
                    </div>
                  </td>
                </tr>

                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td width="33.33%" colSpan={2}>
                      <div className="f15-700 mb-2">Seating preferences</div>
                      <div className="f15-500">
                        {props &&
                          props.seating &&
                          props.seating.seating_preference[0]}
                      </div>
                      <div className="f11-400">
                        Room No. {props.seating && props.seating.room_number}
                      </div>
                    </td>
                    <td width="33.33%" colSpan={2}>
                      <div className="f15-700 mb-2">Special occasion</div>
                      <div className="f15-500">
                        {props && props.seating && props.seating.occasion}
                      </div>
                      {/* <div className="f11-400">
                        {props && props.seating && props.seating.occasion}
                      </div> */}
                    </td>
                    {(props &&
                      props.seating &&
                      props.seating.diner_status === "CANCELLED") ||
                    (props &&
                      props.seating &&
                      props.seating.diner_status === "REJECTED") ? (
                      <> </>
                    ) : (
                      <td width="33.33%" colSpan={2}>
                        <div className="f15-700 mb-2">Total wait time</div>
                        <div className="d-flex justify-content-center align-items-center enTimesLbl">
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/hourglass.svg")}
                            alt="Edit"
                            title="Edit"
                            width="9px"
                          />
                          <span className="f10-500 text-dark pl-2">
                            {props.seating &&
                            props.seating.diner_status === "NOTSEATED"
                              ? time_convert(minutes)
                              : seated_time_difference(minutesSeated)}
                          </span>
                        </div>
                      </td>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </>
  );
};

export default AllSeatingUserModal;
